export const findDefaultMarketFromOptions = (
	queuesOptions = [],
	marketsOptions = [],
) =>
	marketsOptions.find(
		(option) => option.value === queuesOptions[0]?.value.market,
	);
